import React from 'react';
import PropTypes from 'prop-types';
import {colors} from '../../utils/colors.js';

const getVariantColors = (variant) => {
  switch (variant) {
    case 'success':
      return {
        color: 'white',
        backgroundColor: colors.success,
      };
    case 'warning':
      return {
        color: colors.warning,
        backgroundColor: colors.warning10,
      };
    case 'danger':
      return {
        color: 'white',
        backgroundColor: colors.danger,
      };
    case 'info':
      return {
        color: 'white',
        backgroundColor: colors.primaryColor,
      };
    case 'secondary':
      return {
        color: 'white',
        backgroundColor: colors.grey64,
      };
    case 'primary':
      return {
        color: 'white',
        backgroundColor: colors.primaryColor,
      };
    case 'disabled':
      return {
        color: colors.grey,
        backgroundColor: colors.disabled,
      };
    default:
      return {
        color: 'white',
        backgroundColor: colors.primaryColor,
      };
  }
};

const Badge = ({
  children,
  variant = 'primary',
  size = 'md',
  color,
  backgroundColor,
  style = {},
}) => {
  // Size mapping
  const sizeStyles = {
    sm: {
      minWidth: '16px',
      height: '16px',
      padding: '0 4px',
      fontSize: '10px',
    },
    md: {
      minWidth: '20px',
      height: '20px',
      padding: '0 6px',
      fontSize: 'var(--body-xs-size)',
    },
    lg: {
      minWidth: '24px',
      height: '24px',
      padding: '0 8px',
      fontSize: '12px',
    },
  };

  // Variant color mapping
  let variantColor = color;
  let variantBackgroundColor = backgroundColor;

  if (!color && !backgroundColor) {
    const variantColors = getVariantColors(variant);
    variantColor = variantColors.color;
    variantBackgroundColor = variantColors.backgroundColor;
  }

  const badgeStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '9999px',
    fontWeight: 600,
    lineHeight: 1,
    color: variantColor,
    backgroundColor: variantBackgroundColor,
    ...sizeStyles[size],
    ...style,
  };

  return (
    <span style={badgeStyle}>
      {children}
    </span>
  );
};

Badge.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf([
    'primary',
    'secondary',
    'success',
    'danger',
    'warning',
    'info',
    'disabled',
  ]),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  style: PropTypes.object,
};

export default Badge;
